import React, { useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Tooltip } from '@mui/material';
import { extractErrorMessage } from '@loyalty/shared-common';
import { faCalculator } from '@fortawesome/pro-solid-svg-icons/faCalculator';
import { faExclamationTriangle } from '@fortawesome/pro-solid-svg-icons/faExclamationTriangle';
import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { Loader } from '../layout/Loader';

export function LazyCounter({
  getCount,
  pageNumber,
  pageSize,
  filters,
}: {
  getCount: () => Promise<number>;
  pageNumber: number;
  pageSize: number;
  filters: any;
}) {
  const { t } = useTranslation();

  const {
    data: count,
    isPending,
    error,
    mutate,
    reset,
  } = useMutation({
    mutationFn: getCount,
  });

  useEffect(() => {
    reset();
  }, [filters]);

  return (
    <>
      {count === undefined ? (
        <>
          {pageNumber + 1}
          {isPending ? (
            <Loader />
          ) : (
            <Tooltip
              title={t('pagination.get-count')}
              placement="top"
              onClick={() => {
                mutate();
              }}
            >
              <FontAwesomeIcon
                icon={faCalculator}
                style={{ marginLeft: '5px', cursor: 'pointer' }}
              />
            </Tooltip>
          )}
        </>
      ) : (
        <>
          {pageNumber + 1} / {count === 0 ? 1 : Math.ceil(count / pageSize)}
        </>
      )}
      {error && (
        <Tooltip title={extractErrorMessage(error as any)} placement="top">
          <FontAwesomeIcon icon={faExclamationTriangle} style={{ marginLeft: '5px' }} />
        </Tooltip>
      )}
    </>
  );
}
